<template>
  <div class="filter-box page-container-box">
    <!-- <div> -->
      <div :class="['tabs-box', {'new-tabs': isPremium}]">
        <el-tabs v-model="tabsIndex" @tab-click="handleTopSwitch">
          <el-tab-pane v-if="!isPremium" label="官方标签" name="1"></el-tab-pane>
          <el-tab-pane v-else label="官方标签" name="3"></el-tab-pane>
          <el-tab-pane name="2" v-if="!isPremium && newplatformFlag" >
            <span slot="label">
              云起标签
              <el-tooltip class="item" content="云起标签是云起平台专属标签，其中包含互动标签与订单交易属性标签。" placement="top">
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/u103.png"
                  style="vertical-align: middle;width: 14px;margin-top: -2px;cursor: pointer;">
              </el-tooltip>
              </span>
          </el-tab-pane>
        </el-tabs>
        <div class="tip-box">
          <el-tooltip effect="dark" placement="bottom-end">
            <div slot="content">
              <div>官方标签：仅返回人群人数，无具体信息返回,T+1更新</div>
              <div>云起标签：来源于订单、互动、客服端数据，有用户密文pin;交易相关标签实时，互动/客服标签数据是T+1。</div>
            </div>
            <div class="data-tip">
              数据说明<img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/u103.png"
                  style="vertical-align: middle;width: 14px;margin-top: -2px;cursor: pointer;">
                </div>

          </el-tooltip>
        </div>
      </div>
      <div class="filter-content" :class="{'scroll-box': tabsIndex != 2, 'scroll-box2': tabsIndex == 2}">
        <!-- <div style="height: 100%;"> -->
          <!-- 顶部FORM区 -->
          <div class="search-form new-input-box">
            <div class="form-item">
              <div class="form-label"><span style="color: #F56C6C;">*</span>人群名称：</div>
              <div class="form-value">
                <el-input class="input-limit" v-model="form.name" placeholder="请输入人群名称" maxlength="50"
                  show-word-limit @input="crowNameChange"></el-input>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">人群描述：</div>
              <div class="form-value">
                <el-input class="input-limit" v-model="form.description" placeholder="请输入人群描述" maxlength="50"
                  show-word-limit></el-input>
              </div>
            </div>
            <div class="form-item">
              <div class="form-label">选择分类：</div>
              <div class="form-value">
                <el-cascader
                  v-if="form.type == 13"
                  class="form-calcader"
                  v-model="form.classifyId"
                  :options="hdClassifyOptions"
                  :show-all-levels="false"
                  :props="{checkStrictly: true, emitPath: false, expandTrigger: 'hover', value: 'id',label: 'name' }"
                >
                </el-cascader>
                <el-cascader
                  v-else
                  v-model="form.classifyId"
                  :options="customClassifyOptions"
                  :show-all-levels="false"
                  :props="{checkStrictly: true, emitPath: false, expandTrigger: 'hover', value: 'id',label: 'name' }"
                >
                </el-cascader>
              </div>
            </div>
          </div>
          <div class="search-form" style="margin-top: 23px;" v-if="tabsIndex == 2">
            <div class="form-item">
              <div class="form-label"><span style="color: #F56C6C;">*</span>人群类型：</div>
              <div class="form-value">
                <el-checkbox-group v-model="groupType">
                  <el-checkbox style="margin-right: 15px;" :label="1">京东人群</el-checkbox>
                  <el-checkbox style="margin-right: 15px;" :label="2" v-if="newplatformFlag">
                    <div class="flex-cen-xy">
                    云起人群
                    <el-tooltip effect="light" content="云起标签是云起平台专属标签，其中包含互动标签与订单交易属性标签。" placement="top-start">
                      <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/u103.png"
                        style="width: 14px;height:14px;cursor:pointer;margin-left: 8px">
                      <template slot="content">
                        <div>
                          1. 京东人群营销场景：短信、富信、卡片短信及咚咚专享客户触达；
                        </div>
                        <div>
                          2.云起人群营销场景：用于批量发放权益中快捷选择人群、互动活动中指定人群等场景。如需进行短信、富信、卡片短信及咚咚专享客户触达需先进行转化为京东人群
                        </div>
                      </template>
                    </el-tooltip>
                  </div>
                  </el-checkbox>
                </el-checkbox-group>
                <el-checkbox v-if="groupType.indexOf(2) !==-1" v-model="dynamicUpdated" style="margin-right: 15px;" :label="3">
                  <div class="flex-cen-xy">
                    动态更新云起人群
                    <el-tooltip effect="light" content="选择后每日定时更新满足加入人群条件的c端用户于人群包内" placement="top-start">
                      <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/u103.png" style="width: 14px;height:14px;cursor:pointer;margin-left: 8px;">
                    </el-tooltip>
                  </div>
                </el-checkbox>
              </div>
            </div>
          </div>
          <!-- 中间标签选择区 -->
          <div class="crowdBox" style="height: 100%;">
            <!-- 官方标签 -->
            <peopleFilterOfficial v-if="tabsIndex == 1" ref="peopleGf" :isAi="isAi" :visible="tabsIndex == 1" :classifyType="form.type"
              :classifyId="form.classifyId" :editData="editData" :compLoading="compLoading" @setSelectCont="setSelectCont" />
            <!-- 云起标签-运算 -->
            <peopleOperation v-else-if="tabsIndex == 2 && query.isOperation" ref="peopleYq" :visible="tabsIndex == 2" :classifyType="form.type"
              :classifyId="form.classifyId" :editData="editData" :compLoading="compLoading" @setSelectCont="setSelectCont" />
            <!-- 云起标签 -->
            <peopleFilterYq v-else-if="tabsIndex == 2" ref="peopleYq" :visible="tabsIndex == 2" :classifyType="form.type"
              :classifyId="form.classifyId" :editData="editData" :compLoading="compLoading" @setSelectCont="setSelectCont" />
            <!-- 官方标签高级版 -->
            <peopleFilterPremium v-else-if="tabsIndex == 3" ref="peopleGj" :visible="tabsIndex == 3" :classifyType="form.type"
              :classifyId="form.classifyId" :editData="editData" :compLoading="compLoading" @setSelectCont="setSelectCont"
              @startLoad="handleload" />
          </div>
        <!-- </div> -->
      </div>
    <!-- </div> -->
    <!-- 底部按钮 -->
    <!-- <div class="footer-btn-box">
      <el-button class="computed-btn" @click="handlePeopleComputed" v-loading="compLoading">计算人群</el-button>
      <div class="text-label">
        当前已选择
        <span :style="{ color: globalBG }">{{ selectLabelCount }}</span>
        个标签，所选条件人群人数为 <span :style="{ color: globalBG }">{{ population }}</span>人
      </div>
      <jd-button type="break" class="save-btn" @click="handleSave" :loading="shake">保存</jd-button>
    </div> -->
    <!-- 保存成功弹窗 -->
    <el-dialog :visible.sync="successDaiLog" title="提示" width="400px" append-to-body
      custom-class="send-con-dialog">
      <div class="success-tip">
        <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip_success.png" />
        <span>保存人群成功</span>
      </div>
      <div class="btn-group1">
        <jd-button @click="continueCreate">继续创建</jd-button>
        <jd-button type="break" label="前往京东人群" @click="handleCancel(true);" style="padding-left: 40px;"></jd-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
// 官方标签
import peopleFilterOfficial from "@/components/people-filter-official";
// 标签运算(官方标签高级版)
import peopleFilterPremium from "@/components/people-filter-premium";
// 云起标签
import peopleFilterYq from "@/components/people-filter-yq";
// 云起标签-运算
import peopleOperation from "@/components/peopleOperation";
import { compute } from "@/api/manage/memberLabelController";
import { addMemberCrowd, advancedTags } from "@/api/memberCrowd";
import { getTreeData, queryCrowdClassify,yunQiCrowdAdd,queryMemberCrowdDetail} from "@/api/manage/memberCrowdController";
import { getSeller } from "@/api/sellerController";



export default {
  props: {
    showVisible: {
      type: Boolean,
      default: false,
    },
    editDataValue: {
      type: Object,
      default: () => {},
    },
    isAi: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    peopleFilterOfficial,
    peopleFilterYq,
    peopleFilterPremium,
    peopleOperation
  },
  filters: {
    labelExplain(value) {
      var result = value;
      if (value.indexOf("</span>") != -1) {
        // result = "根据客户近半年非大促期间的客户下单数据分析计算出偏好（注：workday工作日，restday休息日）";
        return result.split("<span")[0];
      }
      return result;
    },
  },
  watch: {
    visible: {
      handler(newVal) {
        const {tabsIndex} = this.$route.query
        this.query = this.$route.query || {};
        // setTimeout(()=>{
        if (this.isPremium) {
          this.tabsIndex = '3'
        } else {
          if (this.form.type == 13 || tabsIndex == 2) {
            this.tabsIndex = '2'
            this.form.type = 13
          } else {
            this.tabsIndex = '1'
          }
        }
        // },100)
        this.$forceUpdate()
        if (newVal) {
          this.provinces = [];
          this.goodsClass = [];
          if (this.editData) {
            console.log(this.editData,'========++++++++++++++++++++++++++++++>');
            this.form.name = this.editData.name;
            this.form.description = this.editData.description;
            this.form.precisionCrowdStrategyId = this.editData.precisionCrowdStrategyId;
            this.form.strategyId = this.editData.strategyId;
            if(this.editData.type) this.form.type = this.editData.type
            if (this.isPremium) {
              this.tabsIndex = '3'
            } else {
              if (this.form.type == 13 || tabsIndex == 2) {
                this.tabsIndex = '2'
                this.form.type = 13
              } else {
                this.tabsIndex = '1'
              }
            }
            this.getClassifyOptions(this.form.type, this.editData.classifyId);
            // 以下标签回显功能拆分到人群标签组件中，当前页面不再执行
          } else {
            // this.getClassifyOptions();
          }
          // 以下标签回显功能拆分到人群标签组件中，当前页面不再执行
          return
        } else {
          // 关闭标签筛选后才清空标签内容
          this.$refs.peopleGf && this.$refs.peopleGf.cleanData();
          this.$refs.peopleYq && this.$refs.peopleYq.cleanData();
          this.$refs.peopleGj && this.$refs.peopleGj.cleanData();
        }
      }
    },
    shopInfo(newVal) {
      if (newVal) {
        this.shopMemberType = this.shopInfo.shopMemberType;
      }
    },
    showVisible: {
      handler(newVal){
        if(newVal){
          this.editData = JSON.parse(JSON.stringify(this.editDataValue));
          this.visible = true;
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      dynamicUpdated: false,

      visible: false, // 页面是否打开
      isPremium: false, // 是否高级版
      editData: {}, // 修改数据
      tabsIndex: null,
      query: {},
      shake: false, // 节流
      compLoading: false,
      isOrderHd: false, //京获客资格
      storageOfficialIdList: [], // 缓存已选的官方渠道Id列表
      storageOfficialId: [], // 缓存已选的官方渠道Id
      storageCustomId: [], // 缓存已选的手动录入渠道Id
      isCommonShow: true, // 常用标签显示状态
      loading: false,
      loading1: false,
      mangeQd: true, // 管理渠道
      batchDelId: [], // 批量删除id列表
      checkOfficialIdList: [], // 选中的官方渠道id
      checkedCustomId: [], // 已选自定义渠道id
      allSelectCustomId: [], // 自定义渠道id全选
      allSelectCustomIdDel: [], // 自定义渠道id全选-删除
      tabIndex: "1", // 渠道弹窗tab下标
      manualId: "", // 手动录入id
      qdVisible: false, // 选择渠道弹窗
      labels: 0,
      fasle: false,
      form: {
        name: "",
        description: "",
        type: 1,
        classifyId: 0
      },
      groupType:[],
      dataList: [],
      isShowNew: true,
      defaultShow: true, //无内容时跳出提示图标
      allSelectMembel: [], // 会员入会渠道标签全选
      cityShow: false,
      provinces: [],
      goodsClass: [], //商品类目
      goodsCategoryDialog: false,
      searchStatus: false, // 是否为查询状态
      searchValue: "", // 查询值
      goodsState: false,
      returnSelectGoods: [],
      selectGoodsSkuList: [],
      currentIndex: [], // 第一个值表示dataIndex, 第二个值表示labelIndex
      inputWidth: 200,
      valLength: 0,
      // 选择标签数
      selectLabelCount: 0,
      // 计算人群数量
      population: 0,
      shopMemberType: "",
      // 获取隐藏标签列表
      permissionsList: [],
      // shangpingleimu
      CategoryDialog: false, // 弹框
      goodsIndex: 0, // 品类 下标
      goodsPerantID: -111, // 品类  一类的父ID
      goodpinpei: 0, // 判断商品类目选择第几大类
      pinleiCategory: [], //判断品类和其他类 二选一
      goodsSel: false, // 判断为店铺还是商品名称
      goodsItem: [],
      //品牌
      pinpaiCategory: false,
      brandsList: [],
      brandIndex: 0,
      // advanced: ["", ""],
      flag1: false, // 节流状态
      throttletimer: null, // 节流定时器
      recentlyList: [], // 最近使用列表
      commonUseList: [], // 自定义设置列表
      successDaiLog: false, // 保存成功弹窗
      popoverStatus: true,
      // 选择分类
      customClassifyOptions: [], // 自定义人群分类
      hdClassifyOptions: [], // 互动人群分类
      classifyData: null,
    };
  },
  async created() {
    let query = this.$route.query
    console.log(query, "跳转传入的参数");
    this.isPremium = query.isPremium == "true" ? true : false
    const id = query.id
    if(query.classifyData){
      this.classifyData = JSON.parse(query.classifyData)
      this.form.type = this.classifyData.type
    }
    if(query.tabsIndex == 2){
      this.groupType = [2]
    }
    // 获取详情
    if(id){
      const {data} = await queryMemberCrowdDetail({precisionCrowdStrategyId:id})
      const {type} = this.$route.query
      // 复制
      if(type == 2){
        data.precisionCrowdStrategyId = "";
        data.strategyId = "";
        data.name = data.name + "副本";
        if (data.name.length > 60) {
          data.name = data.name.substr(0, 60);
        }
      }
      this.editData = data
      this.visible = true
    }else{
      this.visible = true
    }
    this.permissionsList = this.$store.getters.loginUserInfo.permissions;
    this.shopMemberType = this.shopInfo.shopMemberType;
    // 注释无用请求
    // advancedTags().then((res) => {
    //   this.advanced = res.data;
    // });
  },

  mounted() {
    var dotDays = localStorage.getItem("dotDays");
    var nowDays = new Date().getDate();
    this.isShowNew = dotDays != nowDays;
    getSeller().then(res => {
      if (res.code == 1) {
        this.isOrderHd = res.data.isOrderHd;
      } else {
        this.$message.warning(res.message);
      }
    });
  },
  computed: {
    newplatformFlag() {
      return this.$store.getters.loginUserInfo.platformFlag;
    },
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    shopInfo() {
      return this.$store.getters.shopInfo;
    },
    // 是否无标签数据
    isNoData() {
      let flag = true
      this.dataList.forEach(item => {
        // 有搜索结果，flag改为false
        if (item.searchWrap) flag = false;
      })
      return flag
    },
    venderType() {
      return this.$store.getters.loginUserInfo.venderType
    }
  },
  methods: {
    handleload() {
      this.$emit("startLoad")
    },
    setSelectCont(val) {
      console.log(val);
      this.selectLabelCount = val
    },
    // 顶部tab切换
    handleTopSwitch(tab,event) {
      const index = tab.name
      this.tabsIndex = index
      if (index == 1) { // 官方标签
        this.form.type = 1
      } else if (index == 2) { // 云起标签
        this.form.type = 13
      } else if (index == 3) { // 官方标签-高级版
        this.form.type = 1
      }
    },
    // 获取人群分类二级选项
    getClassifyOptions(type = 1, classifyId = 0) {
      getTreeData().then(res => {
        let data = res.data[0].children
        console.log(data);
        data.forEach(item => {
          if(item.type == 1){
            this.customClassifyOptions = item.children
          }else if(item.type == 13){
            this.hdClassifyOptions = item.children
          }
        })
        if(this.classifyData != null){
          this.form.classifyId = this.classifyData.id - 0
        }else{
          this.form.classifyId = classifyId;
        }
      })
      // queryCrowdClassify(1).then(res => {
      //   if (res.code == 1) {
      //     this.customClassifyOptions = res.data;
      //     if (type == 1) {
      //       this.form.classifyId = classifyId;
      //     }
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // })
      // queryCrowdClassify(13).then(res => {
      //   if (res.code == 1) {
      //     this.hdClassifyOptions = res.data;
      //     if (type == 13) {
      //       this.form.classifyId = classifyId;
      //     }
      //   } else {
      //     this.$message.error(res.message);
      //   }
      // })
    },
    setItem(key) {
      localStorage.setItem(key, JSON.stringify(new Date()));
    },
    // 保存按钮
    handleSave() {
      if (this.shake) { // 节流
        return
      }
      if (!this.form.name || !(this.form.name && this.form.name.trim())) {
        this.$message.warning("请填写人群名称");
        return false;
      }
      // if (!this.form.description || !(this.form.description && this.form.description.trim())) {
      //   this.$message.warning("请填写人群描述");
      //   return false;
      // }
      // 获取提交参数
      let strategy;
      if (this.tabsIndex == 1) {
        strategy = this.$refs.peopleGf.showLimitAttr();
      } else if (this.tabsIndex == 2) {
        strategy = this.$refs.peopleYq.showLimitAttr();
      } else if (this.tabsIndex == 3) {
        strategy = this.$refs.peopleGj.showLimitAttr();
      }
      // 类型品类 需要选择商品类目
      let catelist = [];
      if (this.tabsIndex == 1) {
        catelist = this.$refs.peopleGf.getCatelistData();
      } else if (this.tabsIndex == 2) {
        catelist = this.$refs.peopleYq.getCatelistData();
      } else if (this.tabsIndex == 3) {
        // catelist = this.$refs.peopleGj.getCatelistData();
      }
      if (catelist === false) return
      // 选择品牌id判断
      let brand = [];
      if (this.tabsIndex == 1) {
        brand = this.$refs.peopleGf.getBrandData();
      } else if (this.tabsIndex == 2) {
        brand = this.$refs.peopleYq.getBrandData();
      } else if (this.tabsIndex == 3) {
        // brand = this.$refs.peopleGj.getBrandData();
      }
      if (brand === false) return
      if (strategy === false) return
      let params;
      if(this.tabsIndex == 2){
        let conditionData = {
          strategy
        }
        if(this.query.isOperation) {
          conditionData.labelBuildType = 1;
        }
        params = Object.assign(this.form, {
          condition:JSON.stringify(conditionData),
          labelBuildType: this.query.isOperation ? 1 : 0,
          isBuildJdCrowd: this.tabsIndex == 2 && this.groupType.includes(1)?true:false,
          isBuildHdCrowd: this.tabsIndex == 2 && this.groupType.includes(2)?true:false,
          source:10
        })
      }else{
        params = Object.assign(this.form, {
          strategy: this.tabsIndex == 3 ? JSON.stringify(...strategy) : JSON.stringify([...strategy, ...catelist, ...brand]),
          labelBuildType: this.tabsIndex == 3 ? 1 : 0
        })
      }
      console.log("保存提交参数", params);
      if(this.tabsIndex == 2){
        if (!params.condition) {
          return;
        }
      }else{
        if (!params.strategy) {
          return;
        }
      }
      if(this.tabsIndex == 2){
        if (params.strategy != "[]") {
          this.shake = true;
          if(this.dynamicUpdated && this.groupType.indexOf(2) != -1){
            params.dynamicUpdated = 1
          }else{
            params.dynamicUpdated = 0
          }
          yunQiCrowdAdd(params).then((res) => {
            this.shake = false;
            if (res && res.code == 1) {
              this.setItem("isFresh");
              this.$store.commit("setRefresh", true);
              this.successDaiLog = true
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.warning("请编辑人群筛选条件");
        }
      }else{
        if (params.strategy != "[]") {
          this.shake = true;
          addMemberCrowd(params).then((res) => {
            this.shake = false;
            if (res && res.code == 1) {
              this.setItem("isFresh");
              this.$store.commit("setRefresh", true);
              this.successDaiLog = true
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.warning("请编辑人群筛选条件");
        }
      }
    },
    // 计算人群按钮
    handlePeopleComputed() {
      // 获取官方标签 or 云起标签
      let params;
      if (this.tabsIndex == 1) {
        params = this.$refs.peopleGf.showLimitAttr();
      } else if (this.tabsIndex == 2) {
        params = this.$refs.peopleYq.showLimitAttr();
      } else if (this.tabsIndex == 3) {
        params = this.$refs.peopleGj.showLimitAttr();
      }
      // 类型品类 需要选择商品类目
      let catelist = [];
      if (this.tabsIndex == 1) {
        catelist = this.$refs.peopleGf.getCatelistData();
      } else if (this.tabsIndex == 2) {
        catelist = this.$refs.peopleYq.getCatelistData();
      } else if (this.tabsIndex == 3) {
        catelist = this.$refs.peopleGj.getCatelistData();
      }
      if (catelist === false) return
      // 选择品牌id判断
      let brand = [];
      if (this.tabsIndex == 1) {
        brand = this.$refs.peopleGf.getBrandData();
      } else if (this.tabsIndex == 2) {
        brand = this.$refs.peopleYq.getBrandData();
      } else if (this.tabsIndex == 3) {
        brand = this.$refs.peopleGj.getBrandData();
      }
      if (brand === false) return
      // 提交
      console.log(params,this.form.type, "保存提交参数============>");
      if (params) {
        this.compLoading = true
        let param = {
          strategy: this.query.isOperation ? JSON.stringify(params) : JSON.stringify([...params, ...catelist, ...brand]),
          type: this.form.type,
          labelBuildType: this.query.isOperation ? 1 : this.tabsIndex == 3 ? 1 : 0
        }
        if (this.tabsIndex == 3) {
          param.strategy = JSON.stringify(...params)
        }
        compute(param).then((res) => {
          if (res && res.code == 1) {
            this.population = res.data.count;
          } else {
            this.$message.warning(res.message);
          }
          this.compLoading = false
        });
      }
    },
    // 取消按钮
    handleCancel(state) {
      if (state) this.successDaiLog = false
      this.$nextTick(() => {
        state ? this.$emit("on-cancel", true) : this.$emit("on-cancel", false);
        this.form.name = "";
        this.form.description = "";
        this.form.type = 1;
        this.form.classifyId = 0;
        this.form.strategyId = '';
        this.form.precisionCrowdStrategyId = '';
        this.mangeQd = true, // 管理渠道
          this.batchDelId = [], // 批量删除id列表
          this.checkOfficialIdList = [], // 选中的官方渠道id
          this.checkedCustomId = [], // 已选自定义渠道id
          this.allSelectCustomId = [], // 自定义渠道id全选
          this.allSelectCustomIdDel = [], // 自定义渠道id全选-删除
          this.tabIndex = "1", // 渠道弹窗tab下标
          this.manualId = "", // 手动录入id
          this.pinleiCategory = [];
        this.goodpinpei = 0;
        this.goodsPerantID = -111; // 品类  一类ID
        this.selectLabelCount = 0;
        this.population = 0;
        this.dataList = [];
        this.brandsList = [];
      })
      this.$router.push("/manage/crowd_management/JD_crowd")
    },
    arrayIndexOf(item, arr) {
      if (Array.prototype.indexOf) {
        return arr.indexOf(item);
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return i;
          }
        }
      }
      return -1;
    },
    // 继续创建
    continueCreate() {
      this.successDaiLog = false;
      // 线上Bug:点击继续创建删除precisionCrowdStrategyId为创建人群而非编辑
      this.form = {
        name: "",
        description: "",
        type: this.tabsIndex==2 ? 13 : 1,
        classifyId: 0,
      }
    },
    crowNameChange(e) {
      this.$emit("nameChange", e);
    },
    getData() {
      return new Promise((resolve, reject) => {
        if (!this.form.name) {
          return reject("请填写人群名称");
        }
        const strategy = this.$refs.peopleGf.showLimitAttr();
        // 类型品类 需要选择商品类目
        const catelist = this.$refs.peopleGf.getCatelistData();
        // 选择品牌id判断
        const brand = this.$refs.peopleGf.getBrandData();
        console.log(brand, "brand");
        console.log(catelist, "catelist");
        console.log(strategy, "strategy");
        if (brand.tipText) return reject(`《${this.form.name}》${brand.tipText}`);
        if (catelist.tipText) return reject(`《${this.form.name}》${catelist.tipText}`);
        if (strategy.tipText) return reject(`《${this.form.name}》${strategy.tipText}`);
        const params = Object.assign(this.form, {
          strategy: JSON.stringify([...strategy, ...catelist, ...brand]),
          labelBuildType: 0,
        });
        if (params.strategy != "[]") {
          resolve(params);
        } else {
          return reject(`《${this.form.name}》请编辑人群筛选条件`);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-limit {
  /deep/ .el-input__inner {
    padding-right: 50px;
  }
}
.tab_box {
  background-color: transparent;
  .tab_all {
    background-color: transparent;
    position: relative;
    .tab_item {
      height: 38px;
      font-size: 14px;
      background: #ECEEF4;
      // font-family:PingFang SC;
      font-weight: 400;
      line-height: 20px;
      color: #666666;
      opacity: 1;
      margin-right: 4px;
      padding: 8px 20px;
      display: inline-block;
      cursor: pointer;
      border-radius: 8px 8px 0px 0px;
    }

    .active {
      background: #FFFFFF;
      color: #1F1F1F;
      box-shadow: -2px -8px 12px rgba(0, 0, 0, 0.05);
      position: relative;
      font-weight: 600;
    }
    .active::before,
    .active::after {
      content: '';
      position: absolute;
      width: 20px;
      height: 20px;
      bottom: 0;
    }
    .active::before {
      left: -19px;
      /* 设置径向渐变 */
      background: radial-gradient(
        circle at 0 0,
        transparent 20px,
        #FFFFFF 20px
      );
    }
    .active::after {
      right: -19px;
      /* 设置径向渐变 */
      background: radial-gradient(
        circle at 20px 0,
        transparent 20px,
        #FFFFFF 20px
      );
    }
    .first::before {
      background: transparent;
    }
    .last::after {
      background: transparent;
    }
    .dataTip {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      color: $theme-color;
    }
  }
}

.filter-box {
  position: relative;
  width: 1440px;
  @media screen and (min-width: 1440px){
    width: 1440px;
    font-size: 14px;
  }
  @media screen and (max-width: 1440px){
    width: 1360px;
    font-size: 12px;
    /deep/ button{
      font-size:12px!important;
    }
    /deep/ .el-radio__label{
      font-size:12px!important;
    }
    /deep/ .el-checkbox__label{
      font-size:12px!important;
    }
    /deep/ .el-input__inner{
      font-size: 12px!important;
    }
    /deep/ .global-select-time__border .time_to_text{
      font-size: 12px!important;
    }
  }
  margin: auto;
  .filter-content {
    .head {
      h4 {
        box-sizing: border-box;
        margin: 0;
        padding-left: 28px;
        height: 54px;
        line-height: 53px;
        border-bottom: 1px solid #f0f0f0;
        color: #2e3458;
        font-size: 16px;
        font-weight: bold;
      }
    }

    .search-form {
      position: relative;
      margin-top: 5px;
      // height: 72px;
      // line-height: 72px;
      border-radius: 0px 8px 8px 8px;
      background: #fff;
      display: flex;
      .form-item {
        display: flex;
        align-items: center;
        // flex: 1;
        margin-right: 50px;
        .form-label {
          display: inline-block;
          text-align: right;
          color: #333333;
          // width: 98px;
        }

        .form-value {
          display: flex;
          align-items: center;
          // flex: 1;
          width: 280px;
          // max-width: 370px;
          .el-checkbox-group{
            display: flex;
          }
        }
        /deep/.el-input__inner:focus {
          border: 1px solid #2768FF;
          }
      }

      .form-right {
        float: right;

        span {
          margin-right: 12px;
        }
      }

      &::after {
        content: "";
        clear: both;
        display: block;
        width: 0;
        height: 0;
        overflow: hidden;
      }
    }
    .crowdBox{
      margin-top: 16px;
      // background: #fff;
      & > div{
        height: 100%;
      }
    }
  }
  .scroll-box {
    height: calc(100% - 85px);
  }
  .scroll-box2 {
    height: calc(100% - 124px);
  }
}

.btn-group {
  position: absolute;
  right: 30px;
  bottom: 20px;
  text-align: right;

  .el-button {
    width: 96px;
  }
}

/**  底部计算保存按钮 */
.footer-btn-box {
  height: 80px;
  padding: 23px 0 21px 28px;
  background-color: #fff;
  font-size: 14px;
  box-shadow: 0px -4px 4px -4px rgba(0, 0, 0, 0.3);

  .text-label {
    display: inline-block;
    vertical-align: middle;
    color: #333;
  }

  .computed-btn {
    width: 82px;
    height: 28px;
    vertical-align: middle;
    margin-right: 8px;
    color: #7F85E9;
    background-color: #F7F8FE;
    border: 1px solid #7F85E9;

    &:hover {
      border: 1px solid #7F85E9 !important;
      background-color: #ecedff;
    }
  }

  .cancel-btn {
    width: 98px;
    height: 36px;
    color: #999999;
    float: right;
    background-color: #fff;
    border: 1px solid #CCCCCC;

    &:hover {
      color: #fe4d45;
      background-color: #fff4f4;
      border: 1px solid #fe4d45;
    }
  }

  .save-btn {
    // width: 98px;
    // height: 36px;
    float: right;
    margin-left: 8px;
    // color: #fff;
    margin-right: 25px;
    /deep/ .el-button {
      width: 100px;
    }
    // border: 1px solid #fe4d45;
    // background: #FE4D45;

    // &:hover {
    //   color: #fff;
    //   opacity: 0.9;
    //   border: 1px solid #fe4d45;
    //   background: #FE4D45;
    // }
  }
}

.send-con-dialog {
  .success-tip {
    text-align: center;
    font-size: 14px;
    color: #333;

    // height: 80px;
    img {
      margin-right: 10px;
      vertical-align: middle;
    }
  }

  .btn-group1 {
    margin-top: 30px;
    text-align: center;
  }
}

.noData {
  img {
    margin-left: 100px;
    margin-top: 93px;
  }
}
.el-cascader{
  width: 100%;
}

.tabs-box {
  position: relative;
  .tip-box {
    position: absolute;
    top: 10px;
    right: 0;
    .data-tip {
      font-size: 14px;
      color: #999999;
    }
  }
}
.mt23 {
  margin-top: 23px;
  border: 1px solid #000;
}
/deep/ .new-tabs .el-tabs .el-tabs__active-bar {
  width: 60px !important;
}
</style>
<style lang="scss">
.tip .el-message-box__content {
  padding-left: 60px !important;
}

// .el-message-box__content {
//   padding: 20px 0 !important;
//   padding-left: 80px !important;
//   text-align: left !important;
// }
// .crowdBox {
//   .attr-box{
//     height: 100%;
//     .attr-rightbigbox{
//       height: 100%;
//     }
//   }
// }
</style>
